export enum SMBGrantCustomQuestionKeys {
  BUSINESS_LICENSE = 'businessLicense',
  TAX_CLEARANCE_LETTER = 'taxClearanceLetter',
  BUSINESS_DESCRIPTION = 'businessDescription',
  SOCIAL_IMPACT = 'socialImpact',
  TEAM_AND_EXPERTISE = 'teamAndExpertise',
  PRIOR_FUNDING = 'priorFunding',
  MARKET_POTENTIAL = 'marketPotential',
  HAS_FINANCIAL_STATEMENTS = 'hasFinancialStatements',
  YEARLY_SALES = 'yearlySales',
  CASH_FLOW_POSITIVE = 'cashflowPositive',
  REVENUE_GOAL = 'revenueGoal',
  CHALLENGES_AND_MITIGATION = 'challengesAndMitigation',
  BUSINESS_PLAN = 'businessPlan',
  BUSINESS_PLAN_DOCUMENTS = 'businessPlanDocuments',
  CAN_COMMIT_TO_SESSIONS = 'canCommitToSessions',
  CAN_COMPLETE_MONTHLY_PROGRESS_REPORTS = 'canCompleteMonthlyProgressReports',
  ANY_CHALLENGES = 'anyChallenges',
}
